import {
    Box,
    Container,
    Typography,
    TextField,
    Snackbar,
    Alert
  } from "@mui/material";
  import { useState } from "react";
  // import { PaystackButton } from "react-paystack";
  import { useLocation } from "react-router-dom";
import HomeNavbar from "../components/home-nav-bar";
  
  const PAYSTACK_PUBLIC_KEY = "pk_live_485db31647eb76b20ff1f1f872187e850ebd37d1";
  
  function Purchase() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const title = queryParams.get("title") || "Journal";
    const price = parseFloat(queryParams.get("price")) || 10000;
  
    const [formData, setFormData] = useState({
      name: '',
      email: '',
      phone_number: ''
    });
  
    const [responseM, setResponseM] = useState({
      message: '',
      severity: ''
    });
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData(prev => ({ ...prev, [name]: value }));
    };
  
    const handleClose = () => {
      setResponseM({ message: '', severity: '' });
    };
  
    // const paystackConfig = {
    //   email: formData.email,
    //   amount: price * 100, // Convert to kobo
    //   publicKey: PAYSTACK_PUBLIC_KEY,
    //   currency: "NGN",
    //   metadata: {
    //     name: formData.name,
    //     phone_number: formData.phone_number,
    //     email: formData.email,
    //   },
    //   onSuccess: () => {
    //     setResponseM({
    //       message: 'Payment successful. Check your email for download link.',
    //       severity: 'success'
    //     });
    //   },
    //   onClose: () => {
    //     setResponseM({
    //       message: 'Payment was not completed',
    //       severity: 'error'
    //     });
    //   },
    // };
  
    const openSupportChat = () => {
      const phone = "2347059148543";
      const message = encodeURIComponent(
        `Hello Good Day,\nI'm from WAJLS website and I need help with a journal purchase.`
      );
      window.open(`https://wa.me/${phone}?text=${message}`, '_blank');
    };
  
    return (
        <Box>
            <HomeNavbar/>
            <Container sx={{ display: 'flex', flexDirection: 'column', mt: 2, p: 3 }} maxWidth="md">
                <Typography sx={{ fontSize: '1.2rem', mb: 2 }}>
                    <strong>{title}</strong>
                </Typography>

                <Typography sx={{ fontSize: '1.1rem', mb: 3 }}>
                    📲 <strong>How it works:</strong> After successful payment, a personal download link will be emailed to you.
                </Typography>
        
        
                <Typography sx={{ fontSize: '1.2rem', mb: 3 }}>
                    💰 <strong>Price:</strong> ₦{price.toLocaleString()}
                </Typography>
        
                
                <TextField
                    name="name"
                    label="Full Name"
                    variant="outlined"
                    fullWidth
                    sx={{ mb: 2 }}
                    value={formData.name}
                    onChange={handleChange}
                />
        
                <TextField
                    name="email"
                    label="Email Address"
                    type="email"
                    variant="outlined"
                    fullWidth
                    sx={{ mb: 2 }}
                    value={formData.email}
                    onChange={handleChange}
                />
        
                <TextField
                    name="phone_number"
                    label="Phone Number"
                    variant="outlined"
                    fullWidth
                    sx={{ mb: 2 }}
                    value={formData.phone_number}
                    onChange={handleChange}
                />
        
                {/* <PaystackButton
                    {...paystackConfig}
                    className="paystack-button"
                    text={`Purchase`}
                    disabled={!formData.name || !formData.phone_number || !formData.email}
                /> */}
        
                <Typography sx={{ mt: 3, fontSize: '0.95rem', textAlign: 'center' }}>
                    Having problems with payment?{' '}
                    <Typography
                    component="span"
                    sx={{ textDecoration: 'underline', cursor: 'pointer', color: 'primary.main' }}
                    onClick={openSupportChat}
                    >
                    Contact support
                    </Typography>
                </Typography>
            </Container>
    
            {responseM.message && (
            <Snackbar open autoHideDuration={5000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={responseM.severity} variant="filled" sx={{ width: '100%' }}>
                {responseM.message}
                </Alert>
            </Snackbar>
            )}
        </Box>
    );
  }
  
  export default Purchase;
  